

import _util from '../../utils/';

const trackService = {
    addRewardAndPunishment (data, resolve, reject) {
    	_util.request({
            url: '/api/TrackForRewardAndPunishment/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },

   
}


export default trackService;



// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/track-service.js